import { PartialTranslation } from '../translations';

export const uz: PartialTranslation = {
  newChat: 'Yangi suhbat',
  search: 'Qidirish',
  user: 'Foydalanuvchi',
  settings: 'Sozlamalar',
  language: 'Til',
  getHelp: 'Yordam olish',
  viewAllPlans: 'Barcha rejalarni ko\'rish',
  learnMore: 'Ko\'proq o\'rganish',
  logOut: 'Chiqish',
  chooseLanguage: 'Выберите язык',
  chooseYourPreferredLanguage: 'Выберите предпочитаемый язык',
  searchLanguages: 'Поиск языков...',
  autoDetect: 'Avtomatik aniqlash',
  noLanguagesFound: 'Языки не найдены',
  askAnything: 'Har qanday narsani so\'rang',
  lawhelperAi: 'Lawhelper.ai',
  personal: 'Shaxsiy',
  freePlan: 'Bepul reja',
  current: 'Текущий',
  close: 'Закрыть',
  archive: 'Архивировать',
  delete: 'Удалить',
  confirmDelete: 'Вы уверены, что хотите удалить этот чат?',
  confirmArchive: 'Вы уверены, что хотите архивировать этот чат?',
  deleteCannotUndo: 'Это действие нельзя отменить.',
  archiveCanFind: 'Вы сможете найти его в списке архива после архивирования.',

  // 资源面板
  resources: 'Resurslar',
  addResource: 'Resurs qo\'shish',
  deleteResource: 'Удалить ресурс',
  noMatchingResourcesFound: 'Подходящие ресурсы не найдены',
  noResourcesAvailable: 'Ресурсы недоступны',
  hideResources: 'Скрыть ресурсы',
  showResources: 'Показать ресурсы',

  // 聊天输入框
  typeMessage: 'Xabar yozing...',
  thinkingOptions: 'Варианты размышления',
  deleteFile: 'Удалить файл',
  clearSelection: 'Очистить выбор',
  addAttachment: 'Ilova qo\'shish',
  sendMessage: 'Xabar yuborish',

  // 思考模式选项
  deepInsight: 'Глубокое понимание · Поверхностный анализ',
  deepInsightDesc: 'Быстрое понимание ключевых моментов',
  deepExploration: 'Глубокое исследование · Комплексный анализ',
  deepExplorationDesc: 'Многомерное углубленное исследование',
  deepDeconstruction: 'Глубокая деконструкция · Систематический аргумент',
  deepDeconstructionDesc: 'Послойный прогрессивный анализ',

  // 写作模式选项
  contractReview: 'Обзор контракта · Выявление рисков',
  contractReviewDesc: 'Анализ пунктов и проверка соответствия',
  textPolish: 'Полировка текста · Профессиональное выражение',
  textPolishDesc: 'Языковая оптимизация и структурная настройка',
  legalDocuments: 'Правовые документы · Стандартный проект',
  legalDocumentsDesc: 'Профессиональное написание правовых документов',

  // 认证和隐私翻译 (English fallback - needs translation)
  login: 'Kirish',
  register: 'Ro\'yxatdan o\'tish',
  welcomeBack: 'LawHelper-ga xush kelibsiz',
  loginSubtitle: 'Sizning AI huquqiy tadqiqot yordamchingiz',
  continueWithGoogle: 'Google bilan davom etish',
  continueWithMicrosoft: 'Microsoft bilan davom etish',
  continueWithWeChat: 'WeChat bilan davom etish',
  orContinueWith: 'yoki davom eting',
  emailTab: 'Email',
  phoneTab: 'Telefon',
  emailPlaceholder: 'Emailingizni kiriting',
  phonePlaceholder: 'Telefon raqamini kiriting',
  codePlaceholder: '6 xonali kodni kiriting',
  sending: 'Yuborilmoqda...',
  verifying: 'Tasdiqlanmoqda...',
  verify: 'Tasdiqlash',
  sendMagicLink: 'Sehrli havolani yuborish',
  getVerificationCode: 'Kodni olish',
  resendCode: 'Kodni qayta yuborish',
  resendIn: 'Qayta yuborish',
  magicLinkSent: 'Sehrli havola emailingizga yuborildi',
  magicLinkHint: 'Biz sizning emailingizga xavfsiz havola yuboramiz',
  otpSent: 'Tasdiqlash kodi yuborildi',
  agreeToTerms: 'Davom etish orqali siz rozilik bildirasiz',
  privacyPolicy: 'Maxfiylik siyosati',
  termsOfService: 'Xizmat shartlari',
  and: 'va',
  privacyTitle: 'Sizning maxfiyligingiz muhim',
  privacyIntro: 'Sizga eng yaxshi tajribani taqdim etish uchun cookie va shunga o\'xshash texnologiyalardan foydalanamiz.',
  essentialCookies: 'Zarur cookie-lar',
  essentialDesc: 'Veb-sayt ishlashi uchun kerak',
  analyticsCookies: 'Analitik cookie-lar',
  analyticsDesc: 'Xizmatni yaxshilashga yordam beradi',
  marketingCookies: 'Marketing cookie-lari',
  marketingDesc: 'Shaxsiy kontent uchun ishlatiladi',
  acceptAll: 'Hammasini qabul qilish',
  essentialOnly: 'Faqat zarurlar',
  customize: 'Sozlash',
  savePreferences: 'Sozlamalarni saqlash',
  back: 'Orqaga',
  readPrivacyPolicy: 'Maxfiylik siyosatimizni o\'qing',
  cookiePolicy: 'Cookie siyosati',
  gdprCompliance: 'GDPR',
  piplCompliance: 'PIPL',

  // AI工具面板
  aiReview: 'AI tekshiruvi',
  aiDraft: 'AI qoralama',
  smartAssistant: 'Shablon',

  // 知识库搜索
  enableKnowledgeSearch: 'Qidiruvni yoqish',
  knowledgeSearchDesc: 'AI hujjatlaringizda qidiradi',
  clickToDisable: "O'chirish",
  clickToEnable: 'Yoqish',

  // Landing page translations
  tagline: 'AI-Powered Legal Intelligence',
  heroTitle1: 'Legal AI',
  heroTitle2: 'Simplified.',
  jurisdictionsLabel: 'Jurisdictions',
  accuracyLabel: 'Accuracy',
  fasterLabel: 'Faster',
  availableLabel: 'Available',
  platformCapabilities: 'Platform Capabilities',
  testimonialQuote: '"LawHelper has transformed how we handle legal work. Contract review is 10x faster, with incredible accuracy."',
  testimonialAuthor: 'Legal Professional',
  testimonialPosition: 'Partner at Top Law Firm',
  viewPricing: 'View Pricing',
  footerPricing: 'Pricing',
  footerPrivacy: 'Privacy',
  footerTerms: 'Terms',
  footerContact: 'Contact',
  footerCopyright: '© 2024 LawHelper. All rights reserved.',

  // Onboarding Guide
  onboardingWelcome: 'Welcome to Lawhelper.ai',
  onboardingSkip: 'Skip',
  onboardingNext: 'Next',
  onboardingPrev: 'Back',
  onboardingGetStarted: 'Get Started',
  onboardingSlide1Title: 'AI Legal Chat',
  onboardingSlide1Desc: 'Ask any legal question and get precise, jurisdiction-aware answers powered by advanced AI.',
  onboardingSlide2Title: 'Case Folder System',
  onboardingSlide2Desc: 'Organize your documents by case. Upload files and control which materials AI uses as context.',
  onboardingSlide3Title: 'Local Folder Access',
  onboardingSlide3Desc: 'Connect local directories in the browser. Preview, edit, and send files to AI chat.',
  onboardingSlide4Title: 'AI Drafting & Review',
  onboardingSlide4Desc: 'Draft legal documents with AI and review contracts to identify risks automatically.',
  onboardingGuide: 'Guide',
  mentionFiles: "Reference a file",

  // Auto-synced keys
  chats: 'Chats',
  archived: 'Archived',
  restore: 'Restore',
  noArchivedChats: 'No archived chats',
  backToChats: 'Back to Chats',
  closeResourcesPanel: 'Close Resources Panel',
  uploading: 'Uploading %{fileName}...',
  processing: 'Processing %{fileName}...',
  uploadSuccess: '✓ %{fileName} uploaded successfully',
  uploadError: '✗ Upload failed: %{error}',
  quickAnswer: 'Tezkor javob',
  quickAnswerDesc: 'Fast response for simple questions',
  cancelRequest: 'Bekor qilish',
  library: 'Kutubxona',
  filterAll: 'Hammasi',
  filterChat: 'Chats',
  filterReview: 'Review',
  filterDraft: 'Draft',
  filterTemplate: 'Template',
  filterForm: 'Form',
  thinking: 'O\\\'ylayapti...',
  thinkingProcess: 'Thinking Process',
  analyzingLegalLogic: 'Analyzing legal logic...',
  lawhelperThinking: 'Lawhelper is thinking...',
  serviceError: 'Service Error',
  uploaded: 'Uploaded',
  settingsGeneral: 'Umumiy',
  settingsNotifications: 'Notifications',
  settingsAppearance: 'Appearance',
  settingsProfile: 'Profile',
  settingsResponseNotifications: 'Response Notifications',
  settingsResponseNotificationsDesc: 'Get notified when AI finishes a response',
  settingsColorMode: 'Color Mode',
  settingsLight: 'Light',
  settingsDark: 'Dark',
  settingsSystem: 'System',
  about: 'Haqida',
  reviewTitle: 'Document Review',
  exitReview: 'Exit Review',
  uploadPrompt: 'Upload PDF to start review',
  uploadButton: 'Select File',
  startChatConfig: 'Type "Review this document" to start',
  reviewPlaceholder: 'Type a message or "Review this document"...',
  analyzing: 'Reviewing...',
  reviewComplete: 'Review Complete',
  issuesFound: 'Found %{count} issues',
  draftTitle: 'Legal Document Drafting',
  draftPlaceholder: 'Edit here or ask AI to generate...',
  analyzingTemplate: 'Analyzing template file %{name}...',
  templateAnalyzed: '✅ Template %{name} analyzed! Tell me how you want to modify or fill this template.',
  templateAnalysisPrompt: 'Analyze key clauses of this template',
  parsingFailed: '⚠️ Failed to parse file, but you can still describe your needs.',
  generating: 'Generating...',
  generatedSuccess: '✅ Document generated! You can view and edit in the editor.',
  drafterWelcome: 'Welcome to AI Document Assistant',
  drafterYouCan: 'You can:',
  drafterUploadTemplate: 'Upload a template for AI to analyze',
  drafterDescribeNeeds: 'Describe your document requirements',
  drafterLetAiHelp: 'Let AI help you draft contracts, agreements, etc.',
  drafterExamples: 'Examples:',
  drafterExampleRental: '"Help me draft a rental agreement"',
  drafterExampleLabor: '"Fill in the labor contract based on template"',
  drafterInputPlaceholder: 'Describe your document needs...',
  drafterThinking: 'Thinking...',
  drafterHistoryTitle: 'History',
  drafterNoHistory: 'No history yet',
  drafterNewChat: 'New Chat',
  drafterHistory: 'History',
  drafterRemoveAttachment: 'Remove attachment',
  drafterLineHeight: 'Line Height',
  drafterLineHeightSuffix: 'x',
  drafterExportWord: 'Export as Word (.docx)',
  drafterExportPdf: 'Export as PDF',
  drafterSave: 'Save Document',
  drafterDownload: 'Download Document',
  drafterUndo: 'Undo',
  drafterRedo: 'Redo',
  drafterBold: 'Bold',
  drafterItalic: 'Italic',
  drafterStrike: 'Strikethrough',
  drafterUnderline: 'Underline',
  drafterHighlight: 'Highlight',
  drafterLink: 'Insert Link',
  drafterAlignLeft: 'Align Left',
  drafterAlignCenter: 'Align Center',
  drafterAlignRight: 'Align Right',
  drafterAlignJustify: 'Justify',
  drafterList: 'List',
  drafterBulletList: 'Bullet List',
  drafterOrderedList: 'Ordered List',
  drafterTaskList: 'Task List',
  drafterOpenResource: 'Open Resources Panel',
  drafterStopGeneration: 'Stop generation',
  drafterAgentMode: 'Agent mode enabled | Click to switch to normal chat',
  drafterAgentModeOn: 'Agent mode enabled | Click to switch to normal chat',
  drafterAgentModeOff: 'Normal chat mode | Click to switch to Agent mode',
  drafterUploadAttachment: 'Upload attachment',
  drafterExit: 'Exit',
  drafterConfirm: 'Confirm',
  drafterOpenLink: 'Open link',
  drafterDeleteLink: 'Delete link',
  drafterQuote: 'Quote',
  workflowTitle: 'AI Workflow',
  workflowRunning: 'Running...',
  workflowReady: 'Ready',
  workflowCompleted: 'Completed',
  workflowStartFailed: 'Workflow start failed',
  workflowExecutionFailed: 'Workflow execution failed',
  workflowInterrupted: 'Workflow interrupted',
  workflowProcessing: 'Processing...',
  workflowStepsCompleted: 'steps completed',
  workflowStepsTotal: 'Workflow completed (%{count} steps)',
  acceptChanges: 'Accept Changes',
  rejectChanges: 'Reject Changes',
  changesAccepted: 'Changes accepted',
  changesRejected: 'Changes rejected',
  stopWorkflow: 'Stop',
  restartWorkflow: 'Restart',
  startDrafting: 'Start Drafting',
  interrupt: 'Stop',
  documentSubject: 'Document Subject *',
  documentType: 'Document Type',
  jurisdiction: 'Jurisdiction',
  specialRequirements: 'Special Requirements (optional)',
  clickStartDrafting: 'Click "Start Drafting" to begin workflow',
  docTypeContract: 'Contract',
  docTypeAgreement: 'Agreement',
  docTypeNotice: 'Notice',
  docTypeLetter: 'Letter',
  docTypePetition: 'Petition',
  docTypeWill: 'Will',
  docTypePowerOfAttorney: 'Power of Attorney',
  countryChina: 'China',
  countryUSA: 'United States',
  countryGermany: 'Germany',
  countryJapan: 'Japan',
  countryFrance: 'France',
  countryUK: 'United Kingdom',
  citationVerified: 'Verified',
  citationUnverified: 'Unverified',
  imageLoadFailed: 'Image failed to load',
  smartDocTitle: 'Aqlli hujjat yordamchisi',
  smartDocChatTitle: 'AI Document Assistant',
  smartDocDropPrompt: 'Drop PDF file here',
  smartDocSelectFile: 'Select File',
  smartDocOr: 'or',
  smartDocWelcomeTitle: 'Welcome to AI Document Assistant',
  smartDocWelcomeYouCan: 'You can:',
  smartDocUploadForAI: 'Upload a template for AI to analyze',
  smartDocDescribeDoc: 'Describe your document requirements',
  smartDocLetAIDraft: 'Let AI help you draft contracts, agreements, etc.',
  smartDocExamples: 'Examples:',
  smartDocExampleRental: '"Help me draft a rental agreement"',
  smartDocExampleLabor: '"Fill in the labor contract based on template"',
  smartDocInputPlaceholder: 'Describe your document needs...',
  smartDocRemoveAttachment: 'Remove attachment',
  smartDocOpenResources: 'Open Resources Panel',
  smartDocExit: 'Exit',
  reviewStartFailed: 'Review workflow start failed',
  reviewFailed: 'Review failed',
  reviewFoundIssues: 'Review complete, found %{count} issues.',
  cannotReadStream: 'Cannot read response stream',
  parseEventFailed: 'Failed to parse workflow event',
  errorPrefix: 'Xatolik',
  unknownError: 'Unknown error',
  file: 'Fayl',
  loading: 'Yuklanmoqda...',
  localFolders: 'Local Folders',
  selectLocalFolder: 'Select Local Folder',
  reselectFolder: 'Change Folder',
  addToContext: 'Add to Chat',
  saveFile: 'Save',
  renameFile: 'Rename',
  fileSaved: 'File saved successfully',
  fileRenamed: 'File renamed to %{name}',
  browserNotSupported: 'Your browser does not support local folder access',
  noFolderSelected: 'Select a local folder to browse files',
  scanningFolder: 'Scanning folder...',
  selectFileToPreview: 'Select a file to preview',
  aiAnalyze: 'AI tahlili',
};
